(function($) {
  $('.menu-anchor-links span').on('click', function(e) {
    var anchorid = $(this).attr('data-to');
    if (anchorid) {
        var elem = document.getElementById(anchorid);
        if (elem) {
            gsap.to(window, {scrollTo: elem});
        } else {
            console.warn('Element with ID ' + anchorid + ' not found.');
        }
    } else {
        console.warn('No anchor ID found.');
    }
  });
})(jQuery);